var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handle",class:_vm.$style.draggableIcon},[_c('img',{attrs:{"src":require("@/assets/images/icons/draggable.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }